import { defineComponent as u, computed as a, createBlock as c, createCommentVNode as p, openBlock as d } from "vue";
import v from "./HeaderListbox.vue.js";
const f = /* @__PURE__ */ u({
  __name: "HeaderItemVersionSelect",
  props: {
    versions: {},
    activeVersion: {}
  },
  emits: ["navigate"],
  setup(i, { emit: r }) {
    const n = i, l = r, s = a(
      () => Object.entries(n.versions).map(([e, o]) => ({
        id: e,
        label: o
      }))
    ), t = a({
      get: () => s.value.find(({ id: e }) => e === n.activeVersion),
      set: (e) => e?.id && l("navigate", e.id, "version")
    });
    return (e, o) => t.value ? (d(), c(v, {
      key: 0,
      modelValue: t.value,
      "onUpdate:modelValue": o[0] || (o[0] = (m) => t.value = m),
      buttonClass: ["header-version-button"],
      buttonName: t.value.label,
      options: s.value,
      static: ""
    }, null, 8, ["modelValue", "buttonName", "options"])) : p("", !0);
  }
});
export {
  f as default
};
